// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2-Mag","active":"downloadDropdown_active__FBPEq"};